import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=48d6fa9a&"
import script from "./LeadDetail.vue?vue&type=script&lang=js&"
export * from "./LeadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports